module.exports = __webpack_public_path__ + "img/figure-12.cfdde7c0.png";